
export default function(state = null, action){

  if (action.type == 'AUTHORIZE_CODE') {
    return null
  }

  if (action.type == 'AUTHORIZE_ERROR'){
    return null
  }

  if (action.type == 'AUTHORIZE_TOKEN'){
    return action.token
  }

  return state
}





// WEBPACK FOOTER //
// ./src/store/token/reducer.js